/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetUserInvitations = {
  id: 'user-organization-invitations.get',
  tag: 'Organization',
  summary: 'Get user organization invitations',
  description: 'Retrieve all user organization invitations',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/user/invitation`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              email: z.string().email(),
              firstName: z.string().min(1),
              middleName: z.string().min(1).nullable().optional(),
              lastName: z.string().min(1),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
